'use strict';
module.exports = {
	Identifier: 'LabWorkspace', Ordinal: 246,
	Entity: { Name: 'Lab', IDField: 'IDLab', Collection: 'Labs', GUIDField: 'GUIDLab' },
	Header: { Eyebrow: 'Lab', Title: (r) => r.Name || `Lab ${r.IDLab}`,
		Actions: [ { Label: 'Edit', Icon: 'fas fa-pen', Style: 'is-link', OnClick: 'goToEdit()' } ], ListRoute: '#/PSRS/Lab/List' },
	Tabs: [
		{ Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'overview' } },
		{ Key: 'tests', Label: 'Tests', Icon: 'fas fa-flask', Content: { kind: 'assoc', ref: 'LabTest' } },
		{ Key: 'specsets', Label: 'Specification Sets', Icon: 'fas fa-vials', Content: { kind: 'assoc', ref: 'LabTestSpecificationSet' } },
		{ Key: 'samples', Label: 'Samples', Icon: 'fas fa-vial', Content: { kind: 'assoc', ref: 'LabSample' } },
	],
	FieldGroups: [ { Name: 'Identity', Fields: [ { Key: 'Name', Label: 'Name', Wide: true }, { Key: 'ExternalLabID', Label: 'External Lab ID', Mono: true }, { Key: 'Notes', Label: 'Notes', Wide: true } ] } ],
};
